import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { FilterIndependentAwardCentres } from 'containers/filters'
import { Table, Data } from 'components/layout/Table'
import { RowSelectorTd, Status } from 'components/misc'
import { awardUnits as awardUnitsLayout } from 'constants/layout'
import { apiConfiguration, apiOrganizations } from 'helpers/decorators/api'
import { meta, permissions, tableCommon } from 'helpers/decorators'
import { Export } from 'containers/misc'
import config from 'config'
import { connect } from 'react-redux'
import { CONFIGURATION_KEYS } from '../../../constants/enums'
import { getLabels } from '../../../helpers/labelHelper'
import { initialize } from 'redux-form'
import { organizations as organizationsApi } from '../../../redux/modules/api'
import BulkOrganizations from '../../bulkChange/BulkOrganizations/BulkOrganizations'

const enhance = compose(
  meta({
    title: 'Independent Award Centers',
    intlKey: 'pageTitle.independent_award_centers'
  }),
  permissions(),
  apiConfiguration(),
  apiOrganizations({
    list: true,
    filter: 'IACs',
    useCommonLimit: true
  }),
  tableCommon(),
  connect(
        ({ auth }) => ({
          activeOrganization: auth.organization
        }),
      { setFilter: organizationsApi.setOrganizationsFilter }
  )
)

class IndependentAwardCenters extends Component {
  static propTypes = {
    permissions: PropTypes.object.isRequired,
    exportOrganizations: PropTypes.func.isRequired,
    organizations: PropTypes.object.isRequired,
    setOrganizationsParams: PropTypes.func,
    isDetail: PropTypes.bool,
    setCommonLimit: PropTypes.func,
    configuration: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired
  }

  addLabelToFilter = label => {
    let initValues = []

    initValues.push({ value: label.id, label: label.name })
    this.props.dispatch(initialize(
        'independent-award-centres-filter',
        { 'labels_label_id@or' : initValues }
    ))
    this.props.setFilter(`labels.label.id=${label.id}`)
  }

  render () {
    const {
      organizations,
      organizations: { loading, listIACs, offset, limit, pages, sort, filter, selectedIds },
      selectableOrganizationIds: selectableIds,
      setOrganizationsParams,
      permissions: userPermissions,
      isDetail,
      setCommonLimit,
      configuration,
      activeOrganization,
      setOrganizationSelectedTo,
      areAllOrganizationsSelected,
      bulkSelectOrganizations
    } = this.props

    const safeSelectedIds = selectedIds || []

    const isOrganizationLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableOrganizationLabels.id}].booleanValue`)

    const exportComponent = (
      <Export
        exportName="Independent Award Centres"
        toExport={this.props.exportOrganizations}
        exportSchemeValue="iacs"
        count={organizations && organizations.count}
      />
    )

    return (
      <div>
        <FilterIndependentAwardCentres
          filterByOperatingAuthority={false}
          isDetail={isDetail}
          configuration={configuration}
          activeOrganization={activeOrganization}
        />
        {isOrganizationLabelsEnabled && <BulkOrganizations selectedIds={safeSelectedIds} />}
        <Table
          loading={loading}
          length={listIACs.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          filter={filter}
          ths={awardUnitsLayout.tableHeaders({ isIac: true, isOrganizationLabelsEnabled })}
          areAllSelected={areAllOrganizationsSelected ? true : undefined}
          bulkSelect={() => bulkSelectOrganizations(safeSelectedIds, selectableIds)}
          setParams={setOrganizationsParams}
          data={organizations}
          permissions={userPermissions}
          exportComponent={exportComponent}
        >
          <Data>
            {listIACs.map(({
                             id,
                             globalId,
                             name,
                             region,
                             organizationType,
                             organizationState,
                             country,
                             coordinators,
                             labels
                           }) => {
              let coordinatorName = '---'

              if (coordinators && coordinators.length > 0) {
                const leadCoordinators = coordinators.filter(c => c.isLeadCoordinator)

                if (leadCoordinators.length > 0) {
                  const leadCoordinator = leadCoordinators[0]

                  coordinatorName = (get(leadCoordinator, 'firstName')
                    || get(leadCoordinator, 'person.firstName')
                    || '---')
                    + ' ' + (
                      get(leadCoordinator, 'lastName')
                      || get(leadCoordinator, 'person.lastName')
                    )
                }
              }


              return (
                <tr key={id}>
                  <RowSelectorTd
                      enabled={selectableIds && selectableIds.includes(id) ? true : undefined}
                      selected={selectedIds && selectedIds.includes(id) ? true : undefined}
                      setSelected={val => setOrganizationSelectedTo(id, val)}
                  />
                  <td>
                    <Link
                      onlyActiveOnIndex={false}
                      to={{
                        pathname: `${config.publicPath}/independent-award-centres/${id}/detail`
                      }}
                    >
                      {globalId}
                    </Link>
                  </td>
                  <td>{name}</td>
                  <td>
                    {coordinatorName}
                  </td>
                  <td>{get(organizationType, 'translationText')}</td>
                  {(userPermissions.isIf || userPermissions.isGbt) &&
                  <td>{get(country, 'name')}</td>}
                  {!userPermissions.isGbt && <td>{get(region, 'name')}</td>}
                  {isOrganizationLabelsEnabled && <td>
                    {labels && getLabels(labels, this.addLabelToFilter)}
                  </td> }
                  <td>
                    <Status state={organizationState} />
                  </td>
                </tr>
              )
            })}
          </Data>
        </Table>
      </div>
    )
  }
}

export default enhance(IndependentAwardCenters)
